"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var utils = _interopRequireWildcard(require("../../shared"));

var _ToggleItem = _interopRequireDefault(require("./ToggleItem"));

require("./Toggle.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
Generic component for Tabs
Accepts one or more Tab component inside
Does not do any state management! See Storybook for examples for state management
*/
function Toggle(_ref) {
  var Component = _ref.componentEl,
      className = _ref.className,
      onChange = _ref.onChange,
      children = _ref.children,
      margin = _ref.margin,
      value = _ref.value,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["componentEl", "className", "onChange", "children", "margin", "value"]);

  var childIndex = 0;

  var childrenWithProps = _react["default"].Children.map(children, function (child) {
    if (!_react["default"].isValidElement(child)) {
      return null;
    }

    var childValue = typeof child.props.value === 'undefined' ? childIndex : child.props.value;
    var selected = childValue === value;
    childIndex += 1;
    return _react["default"].cloneElement(child, {
      selected: selected,
      onChange: onChange,
      value: childValue
    });
  });

  var cssClasses = ['st_toggle'];
  cssClasses = utils.classNames.addClassNames(className, cssClasses);
  cssClasses = utils.spacing.addSpacingClasses({
    margin: margin,
    cssClasses: cssClasses
  });
  return /*#__PURE__*/_react["default"].createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps), childrenWithProps);
} // proptypes definitions


Toggle.propTypes = {
  /** event handler when tab is clicked */
  onChange: _propTypes["default"].func,

  /** extra CSS classes, if any */
  className: utils.classNames.classNameProps,

  /** dom element or component to use for outermost wrapper */
  componentEl: utils.componentEl.props,

  /** margin for component, if any */
  margin: utils.spacing.marginProps,

  /** currently selected Tab, either the index number of the actual value of tab */
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
}; // default props

Toggle.defaultProps = {
  onChange: null,
  className: null,
  margin: null,
  componentEl: utils.componentEl.defaults,
  value: null
};
Toggle.Item = _ToggleItem["default"];
var _default = Toggle;
exports["default"] = _default;